enum Sexo {
    MASCULINO = 0,
    FEMININO = 1
}
export default Sexo;